<script setup lang="ts">
  import type { IUser } from '~/types'
  import type { DropdownMenuItem } from '@nuxt/ui'

  const props = defineProps<{
    openDashBoard: boolean
    user: IUser | null
    items: DropdownMenuItem[]
    currentColor: string
    currentBgColor: string | null | undefined
  }>()

  const model = defineModel<boolean>()
  const statusDropdown = ref(false)

  const showIconCheck = computed(() => (ring: string) => {
    return (
      (props.currentColor && `${props.currentColor}` === ring) ||
      (props.currentBgColor && `${props.currentBgColor}` === ring)
    )
  })
</script>

<template>
  <UDropdownMenu
    v-model:open="model"
    :items="items"
    :ui="{
      content: '!w-64',
    }"
  >
    <div class="absolute relative flex h-8 flex-row items-center gap-2">
      <!-- <UAvatar
        :src="user?.info.avatar"
        class="h-5 w-5 absolute left-1.5 z-20 pointer-events-none"
      /> -->
      <!-- 
      <Button
        size="md"
        variant="soft"
        color="neutral"
        class="cursor-pointer flex grow px-1.5 h-full w-full bg-transparent"
        :class="{
          'bg-elevated text-primary': statusDropdown,
          'pl-9': openDashBoard,
        }"
        :label="openDashBoard ? user?.info.name : ''"
      /> -->

      <!-- <TransitionContainer
        ><UIcon
          v-if="openDashBoard"
          name="i-lucide-chevrons-up-down"
          class="absolute right-2 z-20 pointer-events-none"
      /></TransitionContainer> -->
    </div>

    <template #item="{ item }">
      <div class="flex flex-row items-center gap-2">
        <UAvatar v-if="item.avatar" :src="item.avatar?.src" :icon="!item.avatar?.src ? 'i-lucide-image' : ''" class="size-6" size="xs"/>

        <UIcon v-if="item.icon" :name="item.icon" class="size-5" />

        <span
          v-if="item.ring"
          class="h-2 w-2 rounded-full"
          :style="`background-color: var(--color-${item.ring})`"
        ></span>

        <span v-if="item.label" class="w-46 truncate text-left">{{
            item.label
          }}</span>

        <UIcon
          v-if="item.children"
          name="i-lucide-chevron-right"
          class="absolute right-1"
        />

        <UIcon
          v-if="
            (showIconCheck(item.ring) && !item.custom) ||
            (item.mode && item.custom)
          "
          name="i-lucide-check"
          class="absolute right-1"
        />
      </div>
    </template>
  </UDropdownMenu>
</template>
